import { render, staticRenderFns } from "./SportSubscriptionsList.vue?vue&type=template&id=1fb47ba0&scoped=true"
import script from "./SportSubscriptionsList.vue?vue&type=script&lang=js"
export * from "./SportSubscriptionsList.vue?vue&type=script&lang=js"
import style0 from "./SportSubscriptionsList.vue?vue&type=style&index=0&id=1fb47ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb47ba0",
  null
  
)

export default component.exports